<!-- 销售订单数据操作 -->
<template>
    <div>
        <div v-if="isLoaded">
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs :type="dataActionBox.actionType" :activeName="dataActionBox.boxTitle" :name="'jciName'" :value="'jciName'" :tabslist="tabForm">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <!-- 主要信息 -->
                                <div v-if="scope.index == 0">
                                    <el-form label-width="120px" id="mainInfo" class="baseForm" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                                        <el-row v-if="dataActionBox.actionType != 2">

                                            <el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in formDataList.formlist" :key="formOneKey" :prop="formOneValue.entityField"
                                                :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                                <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                                <!-- 日期 -->
                                                <df-date v-if="formOneValue.fieldType == 'date'" v-model="sendDataInfo[formOneValue.entityField]" :isShowLong="false" :isdisabled="formOneValue.isChange == 0">
                                                </df-date>
                                                <el-tooltip v-else-if="formOneValue.fieldType == 'search'" class="item"
                                                    :disabled="sendDataInfo[formOneValue.entityField]==null||sendDataInfo[formOneValue.entityField]==''?true:false || sendDataInfo[formOneValue.entityField].length<=9" effect="dark"
                                                    :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                                    <!-- 检索方案 -->
                                                    <el-input clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                        @keyup.enter.native="openExtSearch(formOneValue.extractId, formOneValue.entityField)" :disabled="formOneValue.isChange == 0">
                                                        <el-button @click="openExtSearch(formOneValue.extractId, formOneValue.entityField)" slot="append" icon="el-icon-search" :disabled="formOneValue.isChange == 0">
                                                        </el-button>
                                                    </el-input>
                                                </el-tooltip>
                                                <!-- formatter下拉选   :automatic-dropdown="true"-->
                                                <el-select clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter'" @visible-change="selectChange" :disabled="formOneValue.isChange == 0" @change="$forceUpdate()"
                                                    v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                                    <el-option v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key" :label="item.key" :value="item.value">
                                                    </el-option>
                                                </el-select>
                                                <!-- 账期 -->
                                                <el-input @keyup.enter.native="nextFocus(formOneKey)" type="number" v-else-if="formOneValue.entityField == 'credit'" :disabled="formOneValue.isChange == 0"
                                                    v-model="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>
                                                <el-radio-group v-else-if="formOneValue.entityField == 'rmType'" v-model="sendDataInfo[formOneValue.entityField]">
                                                    <el-radio :label="1">全部入库</el-radio>
                                                    <el-radio :label="0">分批入库</el-radio>
                                                </el-radio-group>
                                                <!-- string类型 -->
                                                <el-input @keyup.enter.native="nextFocus(formOneKey, formOneValue.focusField)" v-else :disabled="formOneValue.isChange == 0" v-model.trim="sendDataInfo[formOneValue.entityField]"
                                                    :maxlength="$store.state.inputLength"></el-input>
                                            </el-form-item>
                                        </el-row>
                                        <el-row v-if="dataActionBox.actionType == 2">
                                            <el-form-item :label="formOneValue.showField + ':'" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in formDataList.formlist" :key="formOneKey">
                                                <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)+':'"></label>
                                                <span v-if="formOneValue.isRift == 1">
                                                    <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{sendDataInfo[formOneValue.entityField] }}</a>
                                                </span>
                                                <span v-else-if="formOneValue.fieldType == 'date'">
                                                    <span v-if="sendDataInfo[formOneValue.entityField]">
                                                        {{$common.getLocalTime(sendDataInfo[formOneValue.entityField])}}
                                                    </span>
                                                </span>
                                                <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                            </el-form-item>
                                        </el-row>
                                    </el-form>
                                    <!-- 明细操作 -->
                                    <el-form :inline="true" size="mini">
                                        <!-- 明细信息 :height="mxHeight"-->
                                        <el-table class="baseTable" ref="mxTableRef1" v-if="formDataList.details" :data="sendDataInfo.detailList" border size="mini" :height="mxHeight / 2">
                                            <el-table-column :prop="formOneValue.entityField" :label="formOneValue.showField" v-for="(formOneValue, formOneKey) in formDataList.details" :key="formOneKey" v-if="formOneValue.isShow == 1"
                                                :min-width="formOneValue.fieldWeight" show-overflow-tooltip>
                                                <template slot-scope="scope">
                                                    <span v-if="formOneValue.isRift == 1">
                                                        <a @click="toDetail(sendDataInfo.detailList[scope.$index][formOneValue.riftField])">
                                                            {{
                                                                sendDataInfo.detailList[scope.$index][formOneValue.entityField]
                                                            }}</a>
                                                    </span>
                                                    <!-- 生产日期 -->
                                                    <span v-else-if="formOneValue.fieldType == 'date'">
                                                        <span v-if="sendDataInfo.detailList[scope.$index][formOneValue.entityField]">
                                                            {{
                                                                $common.getLocalTime(sendDataInfo.detailList[scope.$index][formOneValue.entityField])
                                                            }}
                                                        </span>
                                                    </span>
                                                    <span v-else>
                                                        {{
                                                            sendDataInfo.detailList[scope.$index][formOneValue.entityField]
                                                        }}
                                                    </span>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </el-form>
                                    <div id="operateBtn" style="padding: 5px 0;" v-if="dataActionBox.actionType != 2">
                                        <el-button type="primary" size="mini" @click="addDetail()" :disabled="sendDataInfo.detailList.length < 1">
                                            新增明细</el-button>
                                        <el-button type="primary" size="mini" @click="deleteDetails()" :disabled="sendDataInfo.detailList.length < 1 || detailList.length < 1">删除明细</el-button>
                                        <el-input ref="udicode" style="min-width: 300px; max-width: 40%; margin: 0 10px;" @keyup.enter.native="pscharesoudi" autosize placeholder="扫码录入" v-model="udicode">
                                        </el-input>
                                        <el-button type="primary" size="mini" @click="pscharesoudi" :disabled="flag">确定录入</el-button>
                                    </div>
                                    <!-- 明细信息 -->
                                    <el-table class="baseTable" ref="mxTableRef" :height="mxHeight / 2" v-if="formDataList.detailslist" :data="detailList" :row-class-name="rowClassName" :row-style="rowStyle" @row-click="clickEvent"
                                        @selection-change="handleSelectionChange" border size="mini">
                                        <el-table-column width="80" label="选择" v-if="dataActionBox.actionType != 2">
                                            <template slot-scope="scope">
                                                <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border size="mini">
                                                    <i class="el-icon-thumb"></i>
                                                </el-radio>
                                            </template>
                                        </el-table-column>
                                        <el-table-column :prop="formOneValue.entityField" :label="formOneValue.showField" v-for="(formOneValue, formOneKey) in formDataList.detailslist" :key="formOneKey" :min-width="formOneValue.fieldWeight"
                                            show-overflow-tooltip>
                                            <template slot-scope="scope">
                                                <!-- 检索方案 -->
                                                <el-input v-if="formOneValue.fieldType == 'search' && formOneValue.entityField == 'bgmName' && dataActionBox.actionType != 2" clearable
                                                    v-model="detailList[scope.$index][formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                    @keyup.enter.native="openDetailSearch(formOneValue.entityField, formOneValue.setField, scope.$index)">
                                                    <el-button @click="openDetailSearch(formOneValue.entityField, formOneValue.setField, scope.$index)" slot="append" icon="el-icon-search">
                                                    </el-button>
                                                </el-input>
                                                <span v-else-if="formOneValue.isRift == 1">
                                                    <a @click="toDetail(detailList[scope.$index][formOneValue.riftField])">
                                                        {{
                                                            detailList[scope.$index][formOneValue.entityField]
                                                        }}</a>
                                                </span>

                                                <span v-else-if="formOneValue.fieldType == 'date'">
                                                    <span v-if="detailList[scope.$index][formOneValue.entityField]">
                                                        {{
                                                            $common.getLocalTime(detailList[scope.$index][formOneValue.entityField])
                                                        }}
                                                    </span>
                                                </span>
                                                <el-input @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" :ref="formOneValue.entityField" type="number" @input="input(scope.$index)"
                                                    v-else-if="formOneValue.entityField == 'recycleNum' && dataActionBox.actionType != 2" v-model.trim="detailList[scope.$index][formOneValue.entityField]">
                                                </el-input>
                                                <span v-else>
                                                    {{ detailList[scope.$index][formOneValue.entityField]
                                                    }}
                                                </span>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <div class="foot">
                    <div>
                        <el-button v-if="dataActionBox.actionType == 2 && $common.checkIsPrint()" type="primary" @click="showPrintPlan">打印
                        </el-button>
                        <el-button type="primary" @click="initActionBox('sendDataInfo')" v-if="dataActionBox.actionType != 2">取消</el-button>
                        <el-button type="primary" @click="sendDataAction('sendDataInfo',)" v-if="dataActionBox.actionType == 0">保存</el-button>
                        <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType == 1">确定提交</el-button>
                    </div>
                </div>
            </div>
        </div>
        <!-- new明细提取 -->
        <el-dialog :title="exTitle" v-if="DialogExtract" :visible.sync="DialogExtract" :width="exWidth" :modal-append-to-body='true' :append-to-body="true">
            <ExtractionScheme ref="extractionScheme" :id="exId" :ppId="'woamId'" @TranData="getTiqu" @getWidth="getWidth" @sendTitle="getExtractName" />
        </el-dialog>
        <!-- 检索方案 -->
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
            <SearchScheme :isNullFlag="isNullFlag" ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import querRecycle from './querRecycle';
import ExtractionScheme from "../byComponents/ExtractionScheme.vue";
import axios from 'axios'
export default {
    name: "querRecycleAction",
    props: ["actionData"],
    //import引入的组件需要注入到对象中才能使用
    components: { ExtractionScheme },
    data() {
        //这里存放数据
        return {
            //--------------------
            mxHeight: 0,
            isLoaded: false,
            formDataList: querRecycle,
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {},//表单传参信息
            detailObj: {},//明细信息
            selectedDetailsIndex: 0,//明细索引
            tabForm: [
                {
                    jciName: "",
                }
            ], // tab循环的主表单
            DialogExtract: false,//判断是否打开提取弹框
            exWidth: 0,//判断弹框的宽度
            seType: "",//字段
            exTitle: "",//弹框的标题
            selectedRow: [],
            detailList: [],//扫码录入的商品明细列表
            udicode: "",
            flag: false,
            DialogVisible: false,//判断是否打开检索弹框
            parentSearchData: {},
            seIndex: 0,
            seId: 919354910904320,//检索Id
            seWidth: "",//判断弹框的宽度
            seTitle: "",//弹框的标题
            numFlag: false,
            isNullFlag: false,
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        'detailList': {
            handler: function (newValue, oldValue) {
                console.log(newValue);
                this.sendDataInfo.detailList.forEach(item => {
                    item.returningNum = 0
                })
                if (newValue.length > 0) {
                    newValue.forEach(item => {
                        if (item.bgmCode != "" && item.bgmCode != null) {
                            this.addRunningInput(item)
                        }
                    })
                    if (this.dataActionBox.actionType != 2) {
                        //
                        this.addNum()
                    }
                }
            },
            deep: true
        }
    },
    //方法集合
    methods: {
        //
        addNum() {
            this.sendDataInfo.detailList.forEach(item => {
                const woadPnumber = NP.strip(item.woadPnumber) || 0
                const total = NP.plus(NP.plus(NP.strip(item.returningNum) || 0, NP.strip(item.useNum) || 0), NP.strip(item.recycleNum) || 0)
                if (NP.minus(woadPnumber, total) < 0) {
                    this.$message.error('本次回库数量与使用数量、已回库数量之和不能大于销售数量')
                    if (!this.numFlag) {
                        this.deleteDetails()
                    }
                }
            })
        },
        input(index) {
            if (this.dataActionBox.actionType == 2) {
                return
            }
            const currentRow = this.detailList[index]
            const woadId = currentRow.woadId
            // 其他同商品行的本次回库数量之和
            const otherRecycleNum = this.detailList.reduce((sum, item, idx) => {
                if (idx !== index && item.woadId === woadId) {
                    return NP.plus(sum, NP.strip(item.recycleNum) || 0)
                }
                return sum
            }, 0)
            const currentRecycleNum = NP.strip(currentRow.recycleNum) || 0
            // 查找主明细中的对应商品记录
            let matchedItem = null
            let matchedIndex = -1
            for (let i = 0; i < this.sendDataInfo.detailList.length; i++) {
                const item = this.sendDataInfo.detailList[i]
                if (item.woadId === woadId) {
                    matchedItem = item
                    matchedIndex = i
                    break
                }
            }
            if (!matchedItem) {
                return
            }
            const woadPnumber = NP.strip(matchedItem.woadPnumber) || 0
            const useNum = NP.strip(matchedItem.useNum) || 0
            const returnedRecycleNum = NP.strip(matchedItem.recycleNum) || 0
            const totalExpected = NP.plus(NP.plus(otherRecycleNum, currentRecycleNum), NP.plus(useNum, returnedRecycleNum))
            // 计算并同步主明细中该商品的累计回库数量（所有同商品行之和）
            this.sendDataInfo.detailList[matchedIndex].returningNum = this.detailList.reduce((sum, item) => {
                if (item.woadId === woadId) {
                    return NP.plus(sum, NP.strip(item.recycleNum) || 0)
                }
                return sum
            }, 0)
            // 超出销售数量则自动修正为最大允许值并提示
            if (NP.minus(woadPnumber, totalExpected) < 0) {
                const maxThisRecycle = NP.strip(NP.minus(woadPnumber, NP.plus(otherRecycleNum, NP.plus(useNum, returnedRecycleNum))))
                this.detailList[index].recycleNum = maxThisRecycle
                // 修正后重新同步累计回库数量
                this.sendDataInfo.detailList[matchedIndex].returningNum = this.detailList.reduce((sum, item) => {
                    if (item.woadId === woadId) {
                        return NP.plus(sum, NP.strip(item.recycleNum) || 0)
                    }
                    return sum
                }, 0)
                this.numFlag = true
                this.$message.error('本次回库数量与使用数量、已回库数量之和不能大于销售数量')
                return
            }
        },
        //回库数量计算
        addRunningInput(val) {
            this.sendDataInfo.detailList.forEach(item => {
                if (item.woadId === val.woadId) {
                    item.returningNum = NP.plus(NP.strip(item.returningNum) || 0, NP.strip(val.recycleNum) || 0)
                }
            })
        },
        //扫码录入查询批号
        async pscharesoudi() {
            if (this.sendDataInfo.detailList.length < 1) {
                this.udicode = ""
                this.$refs['udicode'].focus()
                this.$message.error("请提取明细")
                return
            }
            if (this.udicode == "") {
                this.$refs['udicode'].focus()
                this.$message.error("请扫码录入")
                return
            }
            var token = null
            token = sessionStorage.getItem('token')
            this.flag = true
            axios({
                // 请求地址
                url: `${this.$store.state.webConfig.dataTwo.requestUrl}/pscha/identifyUDI?udiCode=${this.udicode}`,
                method: 'POST',
                headers: {
                    token: token
                },
            }).then(res => {
                this.flag = false
                if (res.data.status == 200) {
                    this.add(res.data.result)
                } else {
                    this.$message.error(res.data.message)
                }

            })
        },
        add(val) {
            // 找到第一个 bgmCode 为空的行（避免 forEach 重复触发）
            const emptyIndex = this.detailList.findIndex(item => item.bgmCode === "");

            if (emptyIndex !== -1) {
                this.selectedDetailsIndex = emptyIndex;
            } else {
                this.detailList.push(JSON.parse(JSON.stringify(this.detailObj)));
                this.selectedDetailsIndex = this.detailList.length - 1;
            }

            this.openDetailSearch1(val);
            this.$nextTick(() => {
                const refsElTable = this.$refs.mxTableRef;
                if (refsElTable) {
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.detailList[this.selectedDetailsIndex]);
                }
            });
            this.numFlag = false;
        },
        openDetailSearch1(val) {
            this.isNullFlag = true
            this.parentSearchData = {}
            for (let key in this.sendDataInfo) {
                this.parentSearchData[key] = this.sendDataInfo[key];
            }
            for (let key in val) {
                this.parentSearchData[key] = val[key];
            }
            this.seType = "bgmName"
            this.seIndex = this.selectedDetailsIndex
            this.DialogVisible = true
        },
        tabHeight(val) {
            this.mxHeight = val
        },
        //触发提取
        openExtSearch(id, type) {
            this.exId = id;
            this.seType = type
            this.DialogExtract = true;
        },
        getTiqu(val) {
            console.log("提回", val);
            let obj = val;
            this.DialogExtract = false;
            if (val && val != null) {
                for (let key in obj) {
                    if (key == "arrlistbychen") continue;
                    this.sendDataInfo[key] = obj[key];
                }
                this.sendDataInfo.detailList = val.arrlistbychen
                this.sendDataInfo.detailList.forEach(item => {
                    this.$set(item, 'returningNum', 0)
                })
            }
        },
        openDetailSearch(type, setField, index) {
            this.isNullFlag = false
            this.parentSearchData = {}
            this.seType = type
            this.seIndex = index
            this.parentSearchData[type] = this.detailList[index][type]
            for (let key in this.sendDataInfo) {
                this.parentSearchData[key] = this.sendDataInfo[key];
            }
            this.DialogVisible = true
        },
        changeInputModel(val) {
            console.log("返回", val);
            if (val != "" && val != undefined) {
                this.DialogVisible = false;
                if (Array.isArray(val)) {

                } else {
                    for (const key in this.detailObj) {
                        if (key == 'recycleNum') {
                            this.$set(this.detailList[this.seIndex], key, 1)
                        } else {
                            this.$set(this.detailList[this.seIndex], key, val[key])
                        }
                    }
                    this.$set(this.detailList[this.seIndex], 'woadId', val['woadId'])
                    this.$set(this.detailList[this.seIndex], 'psprice', 0)
                    this.$set(this.detailList[this.seIndex], 'price', 0)
                    this.$set(this.detailList[this.seIndex], 'udiCode', this.udicode)
                    this.udicode = ""
                    this.$refs['udicode'].focus()
                    this.numFlag = false
                }
            } else {
                if (this.seType == "bgmName") {
                    if (this.isNullFlag) {
                        this.isNullFlag = false
                        this.udicode = ""
                        this.deleteDetails()
                    }
                }
            }
        },
        //新增明细
        addDetail() {
            var flag = false
            if (this.detailList.length > 0) {
                this.detailList.forEach((item, index) => {
                    if (item.bgmCode == "") {
                        flag = true
                        this.$nextTick(() => {
                            this.selectedDetailsIndex = index
                            this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                            let refsElTable = this.$refs.mxTableRef;
                            refsElTable.clearSelection();
                            refsElTable.toggleRowSelection(
                                this.detailList[this.selectedDetailsIndex]
                            );
                        });
                    }
                })
            }
            if (flag) {
                this.$message.error("请勿重复添加空白行")
                return
            }
            this.detailList.push(
                JSON.parse(JSON.stringify(this.detailObj))
            );
            this.$nextTick(() => {
                this.selectedDetailsIndex = Number(
                    this.detailList.length - 1
                );
                this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                let refsElTable = this.$refs.mxTableRef;
                refsElTable.clearSelection();
                refsElTable.toggleRowSelection(
                    this.detailList[this.selectedDetailsIndex]
                );
            });
        },
        //删除明细
        deleteDetails() {
            this.detailList.splice(this.selectedDetailsIndex, 1);
            this.$nextTick(() => {
                if (this.detailList.length > 1) {
                    this.selectedDetailsIndex = Number(this.selectedDetailsIndex - 1)
                    this.tableNextFocus('bgmName', this.selectedDetailsIndex)
                    let refsElTable = this.$refs.mxTableRef
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.detailList[this.selectedDetailsIndex]);
                } else {
                    this.selectedDetailsIndex = 0
                }
            })
        },
        //上级流入
        openBox() {
            this.dataActionBox.actionType = this.actionData.cate;
            var oldData = this.actionData.oldData;
            this.filterMainField();
            this.init();
            if (this.dataActionBox.actionType == 0) {
                this.dataActionBox.boxTitle = "新增信息";
                this.dataActionBox.openMode = "ltr";
                this.formDataList.formlist.forEach(item => {
                    if (item.entityField == 'woamId') {
                        item.isChange = 1
                    }
                })
                this.$set(this.sendDataInfo, 'rmType', 0)
            } else if (this.dataActionBox.actionType == 1) {
                this.dataActionBox.boxTitle = "编辑信息";
                this.dataActionBox.openMode = "ltr";
                this.detailList = oldData.recycleDetailList
                for (const key in oldData) {
                    this.$set(this.sendDataInfo, key, oldData[key])
                }
                this.formDataList.formlist.forEach(item => {
                    if (item.entityField == 'woamId') {
                        item.isChange = 0
                    }
                })
                this.sendDataInfo.detailList.forEach(item => {
                    this.detailList.forEach(item1 => {
                        if (item.woadId == item1.woadId) {
                            item.recycleNum = item.recycleNum - item1.recycleNum
                        }
                    })
                })
            } else {
                this.dataActionBox.boxTitle = "查看信息";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key])
                }
                this.detailList = dataInfo.recycleDetailList
                this.sendDataInfo.detailList.forEach(item => {
                    this.detailList.forEach(item1 => {
                        if (item.woadId == item1.woadId) {
                            item.recycleNum = item.recycleNum - item1.recycleNum
                        }
                    })
                })

            }
            this.tabForm[0].jciName = this.dataActionBox.boxTitle
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight()
                    } else {
                        this.mxHeight = this.$common.getHeight()
                    }
                }, 16.7)
            });
        },
        // 过滤表单不同类型
        filterMainField() {
            this.formDataList.formlist.forEach(item => {
                if (item.fieldType == 'search' && item.setField) {
                    const arr = item.setField.split(",")
                    arr.forEach(item1 => {
                        this.$set(this.sendDataInfo, item1, "")
                    })
                } else if (item.fieldType == 'number') {
                    this.$set(this.sendDataInfo, item.entityField, 0)
                } else if (item.entityField == 'rmType') {
                    this.$set(this.sendDataInfo, item.entityField, 0)
                } else {
                    this.$set(this.sendDataInfo, item.entityField, "")
                }
            })
            this.$set(this.sendDataInfo, 'detailList', [])
            this.formDataList.detailslist.forEach(item => {
                if (item.fieldType == 'search' && item.setField) {
                    const arr = item.setField.split(",")
                    arr.forEach(item1 => {
                        this.$set(this.detailObj, item1, "")
                    })
                } else if (item.fieldType == 'number') {
                    this.$set(this.detailObj, item.entityField, 0)
                } else {
                    this.$set(this.detailObj, item.entityField, "")
                }
            })
            this.$set(this.sendDataInfo, 'rmType', 0)
        },
        // 表格切换焦点方法
        tableNextFocus(field, index) {
            this.seIndex = index;
            if (field == 'keydown') {
                if (this.sendDataInfo.detailList[index + 1] != undefined) {
                    this.$refs['price'][index + 1].focus()
                    this.selectedDetailsIndex = index + 1
                    this.$nextTick(() => {
                        let refsElTable = this.$refs.mxTableRef
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(this.sendDataInfo.detailList[this.selectedDetailsIndex]);
                    })
                    return
                }
                return
            }
            console.log(this.$refs[field]);
            this.$refs[field][index].focus()
        },
        // 子组件穿透方法
        toDetail(orderId) {
            if (this.dataActionBox.actionType != 2)
                this.$parent.$parent.toDetail(orderId);
            else this.$parent.$parent.$parent.toDetail(orderId);
        },
        // 打印方法
        showPrintPlan() {
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                this.$refs.printPlan.openDia(
                    this.actionData.orderId,
                    this.actionData.printSouce,
                    this.actionData.printJurId
                );
            } else {
                return;
            }
        },
        //确认新增
        async sendDataAction() {
            if (this.sendDataInfo.detailList.length == 0) {
                this.$message.error("请提取明细")
                return
            }
            if (this.detailList.length == 0) {
                this.$message.error("请添加明细")
                return
            }
            var flag = false
            this.detailList.forEach(item => {
                if (item.recycleNum <= 0) {
                    flag = true
                }
            })
            if (flag) {
                this.$message.error("回库数量不能为零")
                return
            }
            const params = {
                detailList: this.detailList,
                woamId: this.sendDataInfo.woamId,
                rmType: this.sendDataInfo.rmType,
            }
            var responseData = ""
            if (this.dataActionBox.actionType == 0) {
                responseData = await this.$http.highvaluerecycleAdd(params);
            } else {
                params.rmId = this.sendDataInfo.rmId
                responseData = await this.$http.highvaluerecycleUpdate(params);
            }
            if (responseData.status == 200) {
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
                this.$emit("drawerCancel");
            } else {
                this.$message.error(responseData.message)
            }
        },

        //取消
        initActionBox() {
            this.$emit("drawerCancel");
            this.init();
        },

        //初始化
        init() {
            for (let key in this.sendDataInfo) {
                if (key == "detailList") {
                    this.sendDataInfo[key] = [];
                } else {
                    this.sendDataInfo[key] = "";
                }
            }
            this.$set(this.sendDataInfo, 'rmType', 0)
        },
        getWidth(e) {
            this.exWidth = e + "%";
        },
        getExtractName(e) {
            this.exTitle = e;
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        // 保存已选择行
        handleSelectionChange(rows) {
            this.selectedRow = rows; // 保存已选择行
        },
        // 监听键盘事件
        keyUp(e) {
            if (e.key == 'F2') {
                e.preventDefault();
                this.deleteDetails()
            } else if (e.keyCode == 40) { // 下键
                // 表格为空，不执行下方 
                if (this.detailList.length == 0) return
                let refsElTable = this.$refs.mxTableRef
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) { // 如果当前没有选中行，则直接选中第一个
                        this.selectedDetailsIndex = 0
                    } else if (this.selectedDetailsIndex == this.detailList.length - 1) { // 如果选中的是最后一行了，那么下一行选中的是第一行
                        this.selectedDetailsIndex = 0
                    } else { // 正常递增
                        this.selectedDetailsIndex++
                    }
                    if (!refsElTable) return
                    let findRow = this.selectedRow.find(c => c.rowIndex == this.selectedDetailsIndex); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(this.detailList[this.selectedDetailsIndex], false);
                        return;
                    }
                    // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.detailList[this.selectedDetailsIndex]); // 把现在当前行勾选
                })
            } else if (e.keyCode == 38) { // 上键
                if (this.detailList.length == 0) return
                let refsElTable = this.$refs.mxTableRef
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) { // 当前没有选中行，则直接选中第一个
                        this.selectedDetailsIndex = 0
                    } else if (this.selectedDetailsIndex == 0) { // 如果选中的是第一行了，那么下一行选中的是最后一行
                        this.selectedDetailsIndex = this.detailList.length - 1
                    } else { // 正常递减
                        this.selectedDetailsIndex--
                    }
                    if (!refsElTable) return
                    let findRow = this.selectedRow.find(c => c.rowIndex == this.selectedDetailsIndex); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(this.detailList[this.selectedDetailsIndex], false);
                        return;
                    }
                    // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.detailList[this.selectedDetailsIndex]); // 把现在当前行勾选
                })
            }

        },

        // 表格方法
        rowClassName({
            row,
            rowIndex
        }) {
            let rowName = "",
                findRow = this.selectedRow.find(c => c.rowIndex === row.rowIndex);
            if (findRow) {
                rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
            }
            return rowName; //也可以再加上其他类名 如果有需求的话
        },

        // 选中行底色逻辑
        rowStyle({
            row,
            rowIndex
        }) {
            Object.defineProperty(row, "rowIndex", { // 给每行添加不可枚举属性rowIndex来标识当前行
                value: rowIndex,
                writable: true,
                enumerable: false
            });
            let rowBackground = {}
            if (row.bgColor && row.bgColor != '') rowBackground.backgroundColor = row.bgColor
            return rowBackground
        },

        // 明细表格点击选中
        clickEvent(row, column, event, params) {
            let refsElTable = this.$refs.mxTableRef; // 获取表格对象
            let findRow = {}
            this.selectedDetailsIndex = row.rowIndex
            findRow = this.selectedRow.find(c => c.rowIndex == row.rowIndex); //找出当前选中行
            //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
            if (findRow && this.selectedRow.length === 1) {
                refsElTable.toggleRowSelection(row, false);
                return;
            }
            // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(row);
        },

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.$nextTick(() => {
            this.openBox();

            this.isLoaded = true;
        });
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        // addEventListener('keydown', this.keyDown)
        addEventListener("keyup", this.keyUp); //创建监听键盘事件
    },
    beforeDestroy() {
        removeEventListener("keyup", this.keyUp);
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
    }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.el-row {
    display: flex;
    flex-wrap: wrap;
    padding-right: 20px;
}

.el-drawer {
    outline: none;
}
</style>
<style>
.el-table .rowStyle {
    background: #fff7ca !important;
}
</style>